export default __webpack_public_path__ + "static/media/IMG_20230506_114307_086.755a574c.jpg";